module.exports = __webpack_public_path__ + "static/media/iternal_logo_symbol.45641512.svg";